import React from "react";
import { Props } from "./types";
import { ProjectStatusesList } from "./projectStatusesList";
import styles from "./styles.scss";

function ProjectPage(_: Props) {
  return (
    <div className={styles.projectPage}>
      <div className={styles.projectStatusesList}>
        <ProjectStatusesList />
      </div>
    </div>
  );
}

export { ProjectPage };
